import styled from "styled-components";
import {ProfileMessagesDividerDefaultBox} from "./profile-messages-divider.default.box";

export const ProfileMessagesDividerCasino777Box = styled(ProfileMessagesDividerDefaultBox)`
    background: #000000;
`;
